// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconLinkAddressInactive = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
            <path
                fill="currentColor"
                d="M9.375,1.125 L9.375,10.875 L1.875,10.875 L1.875,1.125 L9.375,1.125 Z M1.875,0 L0.75,0 L0.75,1.125 L0.75,10.875 L0.75,12 L1.875,12 L9.375,12 L10.5,12 L10.5,10.875 L10.5,1.125 L10.5,0 L9.375,0 L1.875,0 Z M5.625,6 C6.16089821,6 6.65608907,5.71410155 6.92403817,5.25 C7.19198728,4.78589845 7.19198728,4.21410155 6.92403817,3.75 C6.65608907,3.28589845 6.16089821,3 5.625,3 C5.08910179,3 4.59391093,3.28589845 4.32596183,3.75 C4.05801272,4.21410155 4.05801272,4.78589845 4.32596183,5.25 C4.59391093,5.71410155 5.08910179,6 5.625,6 Z M3,9 L8.25,9 L7.5,6.75 L3.75,6.75 L3,9 Z M12,1.875 L12,1.5 L11.25,1.5 L11.25,1.875 L11.25,3.375 L11.25,3.75 L12,3.75 L12,3.375 L12,1.875 Z M12,4.5 L11.25,4.5 L11.25,4.875 L11.25,6.375 L11.25,6.75 L12,6.75 L12,6.375 L12,4.875 L12,4.5 Z M12,7.875 L12,7.5 L11.25,7.5 L11.25,7.875 L11.25,9.375 L11.25,9.75 L12,9.75 L12,9.375 L12,7.875 Z"
            />
        </svg>
    );
};

export default React.memo(IconLinkAddressInactive);
